import type { DashboardSectionTile } from "../types/dashboard.types";
import SectionTile from "./SectionTile";

interface DashboardNavigationGridProps {
  tiles: DashboardSectionTile[];
  onNavigate: (path: string) => void;
}

const DashboardNavigationGrid = ({ tiles, onNavigate }: DashboardNavigationGridProps) => (
  <section className="dashboard-enter grid grid-cols-1 gap-6 [animation-delay:130ms] sm:grid-cols-2 xl:grid-cols-3">
    {tiles.map((tile) => (
      <SectionTile key={tile.key} icon={tile.icon} title={tile.title} description={tile.description} onClick={() => onNavigate(tile.path)} />
    ))}
  </section>
);

export default DashboardNavigationGrid;
